import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import BookingRibbon from "./BookingRibbon";

const SiteLayout = ({ children }) => {
  return (
    <div className="page-wrap relative">
      <Header />
      <main className="pt-24 md:pt-28">{children}</main>
      <Footer />
      <BookingRibbon />
    </div>
  );
};

export default SiteLayout;
